const workspaceSelector = '.assignment_resource__main';
const filtersCollapsedClass = 'assignment_resource__main_filters-collapsed';
const selectedCollapsedClass = 'assignment_resource__main_selected-collapsed';

const setElementAvailable = (element, available) => {
    if (!element) return;

    element.hidden = !available;
    element.toggleAttribute('inert', !available);
};

const setExpandedState = (button, expanded) => {
    if (!button) return;

    button.setAttribute('aria-expanded', expanded.toString());
};

const syncFiltersPanel = (workspace) => {
    const collapsed = workspace.classList.contains(filtersCollapsedClass);
    const expandedPanel = document.querySelector('.assignment-resource-filter-panel__expanded');
    const collapsedPanel = document.querySelector('.assignment-resource-filter-panel__collapsed');

    setElementAvailable(expandedPanel, !collapsed);
    setElementAvailable(collapsedPanel, collapsed);
    setExpandedState(document.getElementById('assignment-resource-collapse-filters'), !collapsed);
    setExpandedState(document.getElementById('assignment-resource-expand-filters'), !collapsed);
};

const syncSelectedPanel = (workspace) => {
    const collapsed = workspace.classList.contains(selectedCollapsedClass);
    const expandedPanel = document.querySelector('.assignment-resource-selected-panel__expanded');
    const collapsedPanel = document.querySelector('.assignment-resource-selected-panel__collapsed');

    setElementAvailable(expandedPanel, !collapsed);
    setElementAvailable(collapsedPanel, collapsed);
    setExpandedState(document.getElementById('assignment-resource-collapse-selected'), !collapsed);
    setExpandedState(document.getElementById('assignment-resource-selected-assignments-button'), !collapsed);
};

export const syncAssignmentResourcePanelState = () => {
    const workspace = document.querySelector(workspaceSelector);
    if (!workspace) return;

    syncFiltersPanel(workspace);
    syncSelectedPanel(workspace);
};

const focusPanelControl = (id) => {
    window.requestAnimationFrame(() => document.getElementById(id)?.focus());
};

const updatePanel = (action) => {
    const workspace = document.querySelector(workspaceSelector);
    if (!workspace) return;

    switch (action) {
        case 'collapse-filters':
            workspace.classList.add(filtersCollapsedClass);
            syncAssignmentResourcePanelState();
            focusPanelControl('assignment-resource-expand-filters');
            break;
        case 'expand-filters':
            workspace.classList.remove(filtersCollapsedClass);
            syncAssignmentResourcePanelState();
            focusPanelControl('assignment-resource-collapse-filters');
            break;
        case 'collapse-selected':
            workspace.classList.add(selectedCollapsedClass);
            syncAssignmentResourcePanelState();
            focusPanelControl('assignment-resource-selected-assignments-button');
            break;
        case 'expand-selected':
            workspace.classList.remove(selectedCollapsedClass);
            syncAssignmentResourcePanelState();
            focusPanelControl('assignment-resource-collapse-selected');
            break;
    }
};

const bindPanelControls = () => {
    if (document.assignmentResourcePanelControlsBound) return;

    document.assignmentResourcePanelControlsBound = true;
    document.addEventListener('click', (event) => {
        const button = event.target.closest('[data-assignment-resource-panel-action]');
        if (!button) return;

        updatePanel(button.dataset.assignmentResourcePanelAction);
    });
};

const bindAssignmentResourceTabs = () => {
    if (document.assignmentResourceTabsBound) return;

    document.assignmentResourceTabsBound = true;
    document.addEventListener('keydown', (event) => {
        const tab = event.target.closest('.assignment-resource-tab[role="tab"]');
        if (!tab) return;

        if (event.key === ' ') {
            event.preventDefault();
            tab.click();
            return;
        }

        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

        const tabs = Array.from(tab.closest('[role="tablist"]')?.querySelectorAll('[role="tab"]') || []);
        if (tabs.length === 0) return;

        const currentIndex = tabs.indexOf(tab);
        let nextIndex;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;

        event.preventDefault();
        tabs[nextIndex]?.focus();
    });
};

window.syncAssignmentResourcePanelState = syncAssignmentResourcePanelState;

document.addEventListener('turbolinks:load', () => {
    if (!document.querySelector(workspaceSelector)) return;

    bindPanelControls();
    bindAssignmentResourceTabs();
    syncAssignmentResourcePanelState();
});
